export default {
  centerMap: false,
  currentVideoIndex: 0,
  currentVideoTime: 0,
  fetchingPlaylist: false,
  linestrings: [],
  noPlaylistFound: false,
  playlist: [],
  step: 50
}
